<template>
 
        <div class="content-wrap">

          <div class="search-wrap">
            <div class="row">
                  <div class="mb-2"><ElLabel name="조회 : 실시간/당해년도"/></div>
            </div>
          </div>
          <div class="search-detail-wrap"></div>

          <div class="text-end py-2">
            <ElButton class="btn btn-primary btn-search" @buttonClick="searchPipeline">검색</ElButton>
          </div>

          
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <h4 class="title-sm mb-0">{{ searchType }}</h4>     
            </div>
            
            <div class="table-btn-group d-flex align-items-center">
              <!-- <ElButton type="share" @buttonClick="shareToUser"></ElButton> -->
              <ElButton type="excelDownload" @buttonClick="excelDown()">
                엑셀다운
              </ElButton>
              <img src="/images/vr.png" alt="" />
              <span class="rd-won">(단위:원)</span>
            </div>
        
          </div>      
          
          <div class="table-responsive table-list">
            <table class="table table-bordered">
              <thead >
                <tr class="band text-nowrap text-center">
                  <th rowspan="3" class="align-middle">구분</th>
                  <th colspan="2" title="Case1 : 매출세금계산서 발행일이 지났는데, 발행여부가 'N'인 경우">매출세금계산서</th>
                  <th colspan="2" title="Case2 : 세금계산서 매입일이 지났는데, 발행여부가 'N'인 경우">매입세금계산서</th>
                  <th colspan="2" title="Case3 : 수금일이 지났는데, 수금여부가 'N'인 경우">수금일</th>
                  <th colspan="2" title="Case4 : 지급일이 지났는데, 지급여부가 'N'인 경우">지급일</th>
                  <th colspan="2" title="Case5 : 우선협상자 선정일이 지났는데, Stage가 Won이 아닌 경우">우선협상자 선정일</th>  
                  <th colspan="2" title="Case6 : PO 발행일이 지났는데, Stage가 Close가 아닌 경우">PO발행일</th>
                  <th>합계</th>
                  <th colspan="3">Pipeline status</th>
                  
                </tr>
                <tr class="band text-center align-top text-nowrap">
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매출금액<span class="th-sfont">(원)</span></th>
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매입금액<span class="th-sfont">(원)</span></th>
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매출금액<span class="th-sfont">(원)</span></th>                  
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매입금액<span class="th-sfont">(원)</span></th>
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매출금액<span class="th-sfont">(원)</span></th>
                  <th class="th-ssfont">영업기회<br>개수</th>
                  <th class="th-ssfont">매출금액<span class="th-sfont">(원)</span></th>
                  <th rowspan="2" class="text-nowrap ">총 영업기회<br>개수</th>
                  <th rowspan="2">Pipeline Size</th>
                  <th rowspan="2"># of Commit deal</th>
                  
                  <th rowspan="2"># of Deal<span class="th-sfont">(Pipeline size기준)</span></th>
                </tr>
              </thead>
              <tbody>
                  <tr v-for="(data,index) of gridOptions.allPipeLineList" :key="index"  class="blank-div" >
                    <td v-for="(column,index) of gridOptions.column" :key="index" 
                    :style="column.field !== 'reg_id'|| column.field == 'user_nm' ? 'width:7rem; text-align:right;  ' : 'text-align:left;'" 
                    :class="rowClass(data)"
                    @click="searchOptyByCase(column.field,data)">
                      
                      <template v-if="column.field.includes('cnt')" >
                        {{ numberFomat( data[column.field]) }}
                      </template>
                  
                      <template v-else-if="column.field != 'reg_id' && column.field != 'pipelinesizeper'">
                        <span :class="isNegative(data[column.field])">{{ numberFomat( data[column.field]) }}</span>
                      </template>
                    
                      <template v-else-if="column.field === 'pipelinesizeper'">
                        <span :class="isNegative(data[column.field])">{{ percentFormat(data[column.field]) }}</span>
                      </template>
                  
                      <template v-else>
                        {{ data[field] }}
                      </template>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
    <ExcelManage
    ref="excelManageRef"
    v-show="false"/>
</template>
  
<script setup>   
import {  onBeforeMount, ref } from "vue";
import common from "@/js/common";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup"
import Row from "primevue/row"
import ExcelManage    from '@/components/common/MCO_EX_001.vue'
import { useLoading } from '@/composable/Loading'
const { setIsLoading } = useLoading()
import { useUserStore } from "@/store/user";
const userStore = useUserStore()
import { getPipeLine_HygieneLIST,getPipeLine_HygieneSalesLIST,getPipeLine_HygieneDtlLIST } from "@/api/monthly";
import { router } from "@/router";


onBeforeMount(async()=>{
  if(userStore.user.authGrpId === 'ADMIN'||userStore.user.authGrpId === 'S'){
    searchType.value = '전체'
  }else if(userStore.user.authGrpId === 'C'){
    searchType.value = '영업대표별'
  }

  await searchPipeline()
})

const searchType = ref('')
const excelManageRef = ref()
const gridOptions = ref({
  columnGroupList : [
  {
      colGroup1 : [
      {header : '구분',rowspan : 3, class:'align-middle'},
        {header : 'Case 1',colspan : 2},
        {header : 'Case 2',colspan : 2},
        {header : 'Case 3',colspan : 2},
        {header : 'Case 4',colspan : 2},
        {header : 'Case 5',colspan : 2},
        {header : 'Case 6',colspan : 2},
        {header : '합계',rowspan : 2 , class:'align-middle'},
        {header : 'Pipeline status',rowspan : 2,colspan : 3 , class:'align-middle'},
        
      ]
    },
    {
      colGroup2 : [
       
        {header : '매출세금계산서',colspan : 2},
        {header : '매입세금계산서',colspan : 2},
        {header : '수금일',colspan : 2},
        {header : '지급일',colspan : 2},
        {header : '우선협상자 선정일',colspan : 2},
        {header : 'PO발행일',colspan : 2},
        
        
      ]
    },
    {
      colGroup3 : [
       
        {header : '개수'},
        {header : '매출금액'},
        {header : '개수'},
        {header : '매입금액'},
        {header : '개수'},
        {header : '매출금액'},
        {header : '개수'},
        {header : '매입금액'},
        {header : '개수'},
        {header : '매출금액'},
        {header : '개수'},
        {header : '매출금액'},
        {header : '총 개수'},
        {header : 'Pipeline Size'},
        {header : '# of Commit deal'},
        {header : '# of Deal (Pipeline size기준)'},
      ]
    },
  ],
  column : [
    {field:'user_nm', classNm: rowClass},
    {field:'cnt1'},
    {field:'revenuevalue1'},
    {field:'cnt2'},
    {field:'revenuevalue2'},
    {field:'cnt3'},
    {field:'revenuevalue3'},
    {field:'cnt4'},
    {field:'revenuevalue4'},
    {field:'cnt5'},
    {field:'revenuevalue5'},
    {field:'cnt6'},
    {field:'revenuevalue6'},
    {field:'total_sales_cnt'},
    {field:'pipelinesizeper'},
    {field:'commitdeal'},
    {field:'commitpipeline'},
  ],
  allPipeLineList : [],
  saleCeoByPipeLineList : []
})

//데이터 조회(전체,영업대표별)
async function searchPipeline(){
  try{
    setIsLoading(true)
    let params = {
      fs_year : new Date().getFullYear(),
      employee_id : userStore.user.employeeId
    }
    //임원,관리자는 전체 검색
    if(['ADMIN', 'E'].includes(userStore.user.authGrpId)) params.employee_id = ''
    let res = await getPipeLine_HygieneLIST(params)
    gridOptions.value.allPipeLineList = [...res.rtn]


    // params['fs_year_1'] = params.fs_year + 1
    // params['employee_id'] = userStore.user.employeeId

    // let res2 = await getPipeLine_HygieneSalesLIST(params)
    // gridOptions.value.saleCeoByPipeLineList = [...res2.rtn]

  }catch(e){
    alert('조회중 에러 발생')
    console.log(e)
  }finally{
    setIsLoading(false)
  }
  
}

function percentFormat(num){
  return isNaN(Number(num)) ? num  : Number(num).toFixed(1)
}


function numberFomat(num){
  return common.checkNumberComma(num)
}

function rowClass(data){
  let classNm = '';

  if(data.user_nm === '합계') classNm = 'total'

  return classNm
}

function excelDown(){
  let fileNm = 'Pipeline Hygiene'
  let header1 = [
    {header : '구분',rowspan : 2,colspan : 1},
    {header : 'Case 1(매출세금계산서)',rowspan : 1,colspan : 2},
    {header : 'Case 2(매입세금계산서)',rowspan : 1,colspan : 2},
    {header : 'Case 3(수금일)',rowspan : 1,colspan : 2},
    {header : 'Case 4(지급일)',rowspan : 1,colspan : 2},
    {header : 'Case 5(우선협상자 선정일)',rowspan : 1,colspan : 2},
    {header : 'Case 6(PO발행일)',rowspan : 1,colspan : 2},
    {header : '합계',rowspan : 1,colspan : 1},
    {header : 'Pipeline status',rowspan : 1,colspan : 3},
  ]

  let header2 = [
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매출금액',rowspan : 1,colspan : 1},
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매입금액',rowspan : 1,colspan : 1},
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매출금액',rowspan : 1,colspan : 1},
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매입금액',rowspan : 1,colspan : 1},
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매출금액',rowspan : 1,colspan : 1},
    {header : '개수',rowspan : 1,colspan : 1},
    {header : '매출금액',rowspan : 1,colspan : 1},
    {header : '총 개수',rowspan : 1,colspan : 1},
    {header : 'Pipeline Size',rowspan : 1,colspan : 1},
    {header : '# of Commit deal',rowspan : 1,colspan : 1},
    {header : '# of Deal (Pipeline size기준)',rowspan : 1,colspan : 1},
  ]
  let header = [header1,header2]
  let dataList = [...gridOptions.value.allPipeLineList]
  let headerProps = gridOptions.value.column.map((item)=>{
    return item.field
  })
  excelManageRef.value.excelDownload(fileNm,header,dataList,headerProps)
}

async function searchOptyByCase(type,data){
  try{
    if(type.includes('cnt')){
      if(type === 'total_sales_cnt') return
      setIsLoading(true)
      let params = {
        type : type.replaceAll('cnt',''),
        user_id : data.reg_id,
        employee_id : data.reg_id
      }

      const res = await getPipeLine_HygieneDtlLIST(params)
      const optyList = [...res.rtn].map((item)=>{ return item.sales_id})

      if(optyList.length >0){
        router.push({path : '/sr/MSR_SO_002', state : { salesIdList: optyList.toString()}});
      }else{
        alert("해당되는 영업기회 조회건이 없습니다.")
      }
      
    }
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

function isNegative(data){
  if(!data) return
  data = data.toString().replaceAll('%','')

  if(Number(data) < 0){
    return 'text-b-rt'
  }
}
</script>
     